// extracted by mini-css-extract-plugin
export default {"titleBar":"Categories_titleBar__G5nSr","btnsContainer":"Categories_btnsContainer__yaMYj","closeButton":"Categories_closeButton__3y8uF"};